<script setup>

</script>

<template>
  <NuxtImg
    src="/imgs/hyatt/hyatt-inclusive-collection-color.png"
    alt="Hyatt Inclusive"
  />
</template>
